export const SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS'
export const SET_BREADCRUMB = 'SET_BREADCRUMB'
export const SET_DOWNLOAD_PROGRESS = 'SET_DOWNLOAD_PROGRESS'
export const SET_OFFLINE = 'SET_OFFLINE'
export const SET_FIREBASE = 'SET_FIREBASE'
export const SET_ACCOUNT = 'SET_ACCOUNT'
export const SET_REQUIRED_PIN = 'SET_REQUIRED_PIN'
export const NOTIF_FIREBASE = 'NOTIF_FIREBASE'
export const SET_AUTO_LOGOUT_TIMER_VALUE = 'SET_AUTO_LOGOUT_TIMER_VALUE'
export const SET_INITIAL_AUTO_LOGOUT_TIMER = 'SET_INITIAL_AUTO_LOGOUT_TIMER'
export const LOGOUT = 'LOGOUT'
export const CHANGERESTAURANT = 'CHANGERESTAURANT'
export const MENU_EDITOR = 'MENU_EDITOR'
export const CLIENT_TYPE_ID = 'CLIENT_TYPE_ID'
export const RESTAURANTS = 'RESTAURANTS'

export const BUSINESS_PROFILE = "BUSINESS_PROFILE"

